export const ROLES = {
  ADMIN: 'admin',
  OFFICIAL: 'official',
};
